export enum ExerciseStatus {
  NEW,
  STARTED,
  COMPLETED,
  UNCOMPLETED,
  INDIVIDUAL,
  FAILED
}
